import React, {Component} from 'react';
class Tabitem extends Component{
    render(){
        var {ticon,text, description} = this.props;
        return(
            <div className={``}>
                <div className="software_service_item mb_70">
                    <i className={ticon}/>
                    <h5 className="mt_30 mb_15">{text}</h5>
                    <p>{description}</p>
                </div>
            </div>
        )
    }
}
export default Tabitem;
